import NivoLineChart from "../../../charts/nivo/NivoLineChart";



const formatSeriesForLineChart = (id, values)=>{
    let series = [];
    for (let i = 0; i < values.length; i++) {
        series.push({
            x: i,
            y: parseFloat((values[i] * 100).toFixed(2))
        });
    }
    return {
        id,
        data: series
    }

}

const formatDataForLineChart = (data)=>{
    let chartData = [];
    data.forEach((d)=>{
        chartData.push(formatSeriesForLineChart(d.label, d.peak_to_valley.percentage_changes));
    });
    return chartData;
}

const PeakToValley = ({data, itemColors})=>{
    console.log('P2V D ', data);

    const chartData = formatDataForLineChart(data);
    return (
        <div style={{height: '500px', width: '100%'}}>
            <NivoLineChart
                data={chartData}
                keys={data.map(d=>d.label)}
                customColors={itemColors}

            />
        </div>
    )
}
export default PeakToValley;